export const generateServiceRequestTableColumns = ({
  user,
  variables,
  from,
  PATHS,
  ICONS,
  USER_ROLES,
  props,
  state,
  setState,
  isGroupExpanded,
  expandGroup,
  collapseGroup,
  selectAllBySRsGroup,
  deselectAllBySRsGroup,
  fetchGroupServiceRequestHandler,
  handleDeleteServiceRequestGroup,
  onClickBulkUpdate,
  serviceRequestTableLocalTime,
  sortByDate,
  moment,
  Checkbox,
  Link,
  Status,
  FontAwesomeIcon,
  IcoMoon,
  Label,
}: any) => {
  return [
    {
      label: '',
      cell: (data) => {
        let selectedObj =
          state.selectedIds.length > 0
            ? state.selectedIds.find((object) => object.id === data.id)
            : null;
        let selectedId =
          selectedObj === undefined || selectedObj === null
            ? null
            : selectedObj && selectedObj.id
              ? selectedObj.id
              : null;
        return (
          <div style={{ flexDirection: 'row', display: 'flex' }}>
            {user.roles[0].role.name === 'Home Owner' ||
            user.roles[0].role.name === 'Vendor' ? null : data.requestType ===
              'Grouping' ? (
              <>
                <Checkbox
                  checked={
                    state.selectedSrsGroupId.findIndex(
                      (group) => group.id === data.id
                    ) !== -1
                  }
                  name={
                    state.selectedSrsGroupId.findIndex(
                      (group) => group.id === data.id
                    ) !== -1
                      ? data.id
                      : null
                  }
                  value={
                    state.selectedSrsGroupId.findIndex(
                      (group) => group.id === data.id
                    ) !== -1
                      ? data.id
                      : ''
                  }
                  onClick={() => {
                    if (
                      state.selectedSrsGroupId.findIndex(
                        (id) => data.id === id.id
                      ) === -1
                    ) {
                      setState((prevState) => ({
                        ...prevState,
                        isGroupSelected: true,
                        selectedSrsGroupId: [...state.selectedSrsGroupId, data],
                        loading: true,
                      }));
                      if (!isGroupExpanded(data)) {
                        expandGroup(data);
                        setTimeout(() => selectAllBySRsGroup(data), 500);
                      } else {
                        selectAllBySRsGroup(data);
                      }
                    } else {
                      setState((prevState) => ({
                        ...prevState,
                        selectedSrsGroupId: state.selectedSrsGroupId.filter(
                          (id) => id.id !== data.id
                        ),
                      }));
                      deselectAllBySRsGroup(data);
                    }
                    setState((prevState) => ({
                      ...prevState,
                      selectAll: false,
                    }));
                  }}
                  readOnly
                />
                {isGroupExpanded(data) ? (
                  <>
                    <div
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        collapseGroup(data);
                      }}
                    >
                      <FontAwesomeIcon
                        glyph="angle-up"
                        weight="regular"
                        size="big"
                      />{' '}
                      &nbsp;&nbsp;
                    </div>
                    <span
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleDeleteServiceRequestGroup(data)}
                    >
                      {' '}
                      <FontAwesomeIcon
                        glyph="object-ungroup"
                        weight="regular"
                        size="big"
                      />{' '}
                      &nbsp;&nbsp;
                    </span>
                  </>
                ) : (
                  <div
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      expandGroup(data);
                      fetchGroupServiceRequestHandler(data.id);
                      state.selectedGroupServiceRequestId.push({
                        id: data.id,
                      });
                    }}
                  >
                    <FontAwesomeIcon
                      glyph="angle-down"
                      weight="regular"
                      size="big"
                    />{' '}
                    &nbsp;&nbsp;
                  </div>
                )}
              </>
            ) : (
              <Checkbox
                checked={selectedId === data.id}
                name={selectedId ? selectedId : null}
                value={selectedId ? selectedId : ''}
                onClick={() => onClickBulkUpdate(data.id, data)}
                readOnly
              />
            )}
            {data.requestType === 'Grouping' ? (
              <></>
            ) : (
              <Link
                to={{
                  pathname: PATHS.SERVICE_REQUESTS_VIEW.replace(':id', data.id),
                  state: { navigateTo: props.navigateTo },
                }}
              ></Link>
            )}
          </div>
        );
      },
      style: { width: '7rem' },
      minWidth: '7rem',
    },
    {
      label:
        from === 'CommonArea' ? 'CommonArea #' : `${variables.Suite} | SL #`,
      sortable: true,
      cell: (data) =>
        data.requestType === 'Grouping' ? (
          from === 'CommonArea' ? (
            data.commonAreaName
          ) : data.suiteName ? (
            <div
              title={
                data.suiteName + (data.stratalot ? ' | ' + data.stratalot : '')
              }
              className="cut-text"
            >
              {data.suiteName + (data.stratalot ? ' | ' + data.stratalot : '')}
            </div>
          ) : (
            <div
              title={
                data.requestType === 'Grouping'
                  ? data.ticketNumber
                  : 'Common Area'
              }
              className="cut-text"
            >
              {data.requestType === 'Grouping'
                ? data.ticketNumber
                : 'Common Area'}
            </div>
          )
        ) : (
          <Link
            to={{
              pathname: PATHS.SERVICE_REQUESTS_VIEW.replace(':id', data.id),
              state: { navigateTo: props.navigateTo },
            }}
          >
            {from === 'CommonArea' ? (
              <div title={data.commonAreaName}>{data.commonAreaName}</div>
            ) : data.suiteName ? (
              <div
                title={
                  data.suiteName +
                  (data.stratalot ? ' | ' + data.stratalot : '')
                }
                className="cut-text"
              >
                {data.suiteName +
                  (data.stratalot ? ' | ' + data.stratalot : '')}
              </div>
            ) : data.requestType === 'Grouping' ? (
              <div title={data.ticketNumber}>{data.ticketNumber}</div>
            ) : (
              <div title={'Common Area'}>Common Area</div>
            )}
          </Link>
        ),
      accessor: 'sortableUnitName',
      style: { width: '13rem' },
      minWidth: '13rem',
    },
    {
      xsHide: true,
      label: 'Description',
      sortable: true,
      accessor: 'description',
      cell: (data) => <div title={data.description}>{data.description}</div>,
      minWidth: '35rem',
    },
    {
      xsHide: true,
      label: 'Room/Area',
      sortable: true,
      accessor: 'sortableCommonAreaName',
      cell: (data) =>
        data.commonAreaName
          ? data.commonAreaName
          : data.area && data.area.name
            ? data.area.name
            : '',
      style: { width: '13rem' },
      minWidth: '13rem',
    },
    {
      xsHide: true,
      label: 'Asset',
      sortable: true,
      accessor: 'itemName',
      cell: (data) => data.itemName,
      style: { width: '10rem' },
      minWidth: '10rem',
    },
    {
      xsHide: true,
      label: 'Type',
      sortable: true,
      accessor: 'sortableIssueType',
      cell: (data) => (
        <div
          title={
            data.requestType !== 'Grouping'
              ? data.requestType === 'CommonArea'
                ? 'Common'
                : data.requestType === null
                  ? 'Warranty'
                  : data.requestType
              : ''
          }
          className="cut-text"
        >
          {data.requestType !== 'Grouping'
            ? data.requestType === 'CommonArea'
              ? 'Common'
              : data.requestType
            : ''}
        </div>
      ),
      style: { width: '8rem' },
      minWidth: '8rem',
    },
    {
      label: 'Status',
      showOverflow: true,
      sortable: true,
      accessor: 'status',
      cell: (data) => (
        <>
          <Status
            icon={
              data.status === 'Under Review' ? (
                <FontAwesomeIcon
                  glyph="hourglass-end"
                  weight="light"
                  size="solid"
                />
              ) : data.status === 'One Year Warranty' ? (
                <FontAwesomeIcon
                  glyph="certificate"
                  weight="solid"
                  size="solid"
                />
              ) : (
                <IcoMoon glyph={ICONS[data.status]} />
              )
            }
            label={<div title={data.status}>{data.status}</div>}
          />
        </>
      ),
      style: { width: '10rem' },
      minWidth: '10rem',
    },
    {
      label: 'Submitted On',
      sortable: true,
      accessor: 'createdDate',
      sortingAlgorithm: sortByDate,
      cell: (data) => {
        const days = moment().diff(moment(data.createdDate), 'days');
        const color = days <= 30 ? 'teal' : days <= 60 ? 'yellow' : 'red';
        return (
          <Label
            color={color}
            label={serviceRequestTableLocalTime(data.createdDate)}
          />
        );
      },
      style: { width: '10rem' },
      minWidth: '10rem',
    },
    // Conditional warranty/assigned to column
    ...(user.roles[0].role.name?.toUpperCase() ===
      USER_ROLES.PROPERTY_DEVELOPER.toUpperCase() ||
    user.roles[0].role.name?.toUpperCase() ===
      USER_ROLES.STRATA_MANAGER.toUpperCase() ||
    user.roles[0].role.name?.toUpperCase() ===
      USER_ROLES.SERVICE_PROVIDER.toUpperCase() ||
    user.roles[0].role.name?.toUpperCase() ===
      USER_ROLES.SERVICE_MANAGER.toUpperCase()
      ? [
          {
            xsHide: true,
            sortable: true,
            accessor:
              localStorage.getItem('theme') === 'Essence'
                ? 'warrantyStartDate'
                : 'serviceProvider',
            sortingAlgorithm:
              localStorage.getItem('theme') === 'Essence'
                ? sortByDate
                : undefined,
            label:
              localStorage.getItem('theme') === 'Essence'
                ? 'Warranty Start Date'
                : 'Assigned To',
            cell: (data) =>
              localStorage.getItem('theme') === 'Essence' ? (
                <div
                  title={serviceRequestTableLocalTime(data.warrantyStartDate)}
                  className="cut-text"
                >
                  {serviceRequestTableLocalTime(data.warrantyStartDate)}
                </div>
              ) : (
                <div title={data.serviceProvider} className="cut-text">
                  {data.serviceProvider}
                </div>
              ),
            style: { width: '13rem' },
            minWidth: '13rem',
          },
        ]
      : []),
    // Conditional scheduled date column.
    ...(user.roles[0].role.name?.toUpperCase() ===
      USER_ROLES.PROPERTY_DEVELOPER.toUpperCase() ||
    user.roles[0].role.name?.toUpperCase() ===
      USER_ROLES.STRATA_MANAGER.toUpperCase() ||
    user.roles[0].role.name?.toUpperCase() ===
      USER_ROLES.SERVICE_PROVIDER.toUpperCase() ||
    user.roles[0].role.name?.toUpperCase() ===
      USER_ROLES.SERVICE_MANAGER.toUpperCase()
      ? [
          {
            xsHide: true,
            sortable: true,
            accessor: 'scheduleDatest',
            sortingAlgorithm: sortByDate,
            label: 'Scheduled Date/Time',
            cell: (data) => (
              <div title={data.scheduleDatest ? data.scheduleDatest : null}>
                {data.scheduleDatest ? data.scheduleDatest : null}
              </div>
            ),
            style: { width: '10rem' },
            minWidth: '10rem',
          },
        ]
      : []),
  ];
};
